
import { Component, OnInit } from "@angular/core";
import { CatConsumoTarifasService } from "../../servicios/cat-consumo-tarifas.service";
import { CatTipoPeriodosService } from "../../servicios/cat-tipo-periodos.service";
import { CatTipoConsumosService } from "../../servicios/cat-tipo-consumos.service";
import { CatDiametroTomasService } from "../../servicios/cat-diametro-tomas.service";
import { CatTipoUsosService } from "../../servicios/cat-tipo-usos.service";
import { CatTipoServiciosService } from "../../servicios/cat-tipo-servicios.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatConsumoTarifas, Privilegios } from "../../entidades/entidades";
import { CatTipoPeriodos } from "../../entidades/entidades";
import { CatTipoConsumos } from "../../entidades/entidades";
import { CatDiametroTomas } from "../../entidades/entidades";
import { CatTipoUsos } from "../../entidades/entidades";
import { CatTipoServicios } from "../../entidades/entidades";
import { Router } from '@angular/router';
import { PrivilegiosService } from '../../servicios/privilegios.service';
@Component({
  selector: "app-cat-consumo-tarifas-grid",
  templateUrl: "./cat-consumo-tarifas-grid.component.html",
  styleUrls: ["./cat-consumo-tarifas-grid.component.css"],
})
export class CatConsumoTarifasGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catTipoPeriodos: SelectItem[];
  catTipoPeriodosFiltro: SelectItem[];
  catTipoConsumos: SelectItem[];
  catTipoConsumosFiltro: SelectItem[];
  catDiametroTomas: SelectItem[];
  catDiametroTomasFiltro: SelectItem[];
  catTipoUsos: SelectItem[];
  catTipoUsosFiltro: SelectItem[];
  catTipoServicios: SelectItem[];
  catTipoServiciosFiltro: SelectItem[];
  catConsumoTarifas: CatConsumoTarifas[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  public progressBar = false;
  clonedCatConsumoTarifas: { [s: string]: CatConsumoTarifas } = {};

  constructor(
   private catConsumoTarifasService: CatConsumoTarifasService,
    private catTipoPeriodosService: CatTipoPeriodosService,
    private catTipoConsumosService: CatTipoConsumosService,
    private catDiametroTomasService: CatDiametroTomasService,
    private catTipoUsosService: CatTipoUsosService,
    private catTipoServiciosService: CatTipoServiciosService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
  ) {}

  async ngOnInit() {
    //Valida Permiso
    const tienePermiso = await this.getPrivilegios();
    debugger;
    if (!tienePermiso) {
      this.progressBar = false;
      this.muestraMensaje.warning("No tiene permiso para acceder a este módulo.", "top", "center");
      return; // Detener ejecución
    }
    // =================================================================
    this.progressBar = true;
    await this.getAllCatTipoPeriodos();
    await this.getAllCatTipoConsumos();
    await this.getAllCatDiametroTomas();
    await this.getAllCatTipoUsos();
    await this.getAllCatTipoServicios();
    await this.getAllCatConsumoTarifas();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    this.itemsMenu = [
      {
        label: "Agregar",
        icon: "pi pi-file-o",
        command: () => this.add(),
      },
      {
        label: "Guardar",
        icon: "pi pi-save",
        command: (event) => {
          this.guardarGridCatConsumoTarifas();
        },
      },
      {
        label: "Refrescar",
        icon: "pi pi-refresh",
        command: (event) => {
          this.getAllCatConsumoTarifas();
        },
      },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    this.columnasTabla = [
      {
        field: "operacion",
        header: "Editar",
        ordenar: false,
        styleHeader: "width: 50px;",
      },
     /* {
        field: "acciones",
        header: "Eliminar",
        ordenar: false,
        styleHeader: "width: 60px;",
      },*/
      {
        field: "idTipoServicio",
        header: "Tipo Servicio",
        ordenar: true,
        styleHeader: "width: 200px;",
      },
      {
        field: "idTipoPeriodo",
        header: "Tipo Periodo",
        ordenar: true,
        styleHeader: "width: 200px;",
      },
      {
        field: "idTipoUso",
        header: "Tipo Uso",
        ordenar: true,
        styleHeader: "width: 200px;",
      },
      {
        field: "idTipoConsumo",
        header: "Tipo Consumo",
        ordenar: true,
        styleHeader: "width: 200px;",
      },
      {
        field: "idDiametroTomaIni",
        header: "Diametro Toma Ini",
        ordenar: true,
        styleHeader: "width: 80px;",
      },
      {
        field: "idDiametroTomaFin",
        header: "Diametro Toma Fin",
        ordenar: true,
        styleHeader: "width: 70px;",
      },
      {
        field: "consumoIni",
        header: "Consumo Ini",
        ordenar: true,
        styleHeader: "width: 70px;",
      },
      {
        field: "consumoFin",
        header: "Consumo Fin",
        ordenar: true,
        styleHeader: "width: 70px;",
      },
      {
        field: "cuota",
        header: "Cuota",
        ordenar: true,
        styleHeader: "width: 80px;",
      },
      {
        field: "cuotaUnidadAdicional",
        header: "Cuota Unidad Adicional",
        ordenar: true,
        styleHeader: "width: 70px;",
      },
      {
        field: "anio",
        header: "Año",
        ordenar: true,
        styleHeader: "width: 70px;",
      },
    ];
  }
  async getPrivilegios() {
    try {
      let objUrl = new Privilegios();
      objUrl.descripcion = this.router.url + '/tdc';
      let conPrivilegio = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
      return conPrivilegio;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
    }
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  add() {
    let catConsumoTarifasNew = new CatConsumoTarifas();
    catConsumoTarifasNew.cambio = true;
    catConsumoTarifasNew.id = 0;
    catConsumoTarifasNew.numRow = this.catConsumoTarifas.length + 1;
    this.catConsumoTarifas.unshift(catConsumoTarifasNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  onEditInit(event) {
    let catConsumoTarifasEdit = event.data;
    this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id] = { ...catConsumoTarifasEdit };
    catConsumoTarifasEdit.cambio = true;
    catConsumoTarifasEdit.baja = false;
  }

  onEditCancel(event) {
    let catConsumoTarifasEdit = event.data;
    let index = this.catConsumoTarifas.findIndex(
      (obj) => obj.id === catConsumoTarifasEdit.id
    );
    this.catConsumoTarifas[index] = this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id];
    delete this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id];
  }

  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  async onEditComplete(event) {
    try {
      let catConsumoTarifasEdit = event.data;

      //Valida si hay cambios
      if (
        catConsumoTarifasEdit.id === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].id &&
        catConsumoTarifasEdit.idTipoServicio === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idTipoServicio &&
        catConsumoTarifasEdit.idTipoPeriodo === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idTipoPeriodo &&
        catConsumoTarifasEdit.idTipoUso === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idTipoUso &&
        catConsumoTarifasEdit.idTipoConsumo === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idTipoConsumo &&
        catConsumoTarifasEdit.idDiametroTomaIni === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idDiametroTomaIni &&
        catConsumoTarifasEdit.idDiametroTomaFin === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].idDiametroTomaFin &&
        catConsumoTarifasEdit.consumoIni === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].consumoIni &&
        catConsumoTarifasEdit.consumoFin === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].consumoFin &&
        catConsumoTarifasEdit.cuota === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].cuota &&
        catConsumoTarifasEdit.cuotaUnidadAdicional === this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id].cuotaUnidadAdicional 
      ) {

        let index = this.catConsumoTarifas.findIndex((obj) => obj.numRow === catConsumoTarifasEdit.numRow);
        this.catConsumoTarifas[index] = { ...this.clonedCatConsumoTarifas[catConsumoTarifasEdit.numRow] };
        return;
   
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catConsumoTarifasEdit.cambio = true;
      catConsumoTarifasEdit.baja = false;
      delete this.clonedCatConsumoTarifas[catConsumoTarifasEdit.id];
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  async guardarGridCatConsumoTarifas() {
    try {
      this.progressBar = true;
      for (let catConsumoTarifasFor of this.catConsumoTarifas) {
        if (catConsumoTarifasFor.baja) {
          await this.deleteCatConsumoTarifas(catConsumoTarifasFor);
        } else if (catConsumoTarifasFor.cambio) {
          if (catConsumoTarifasFor.id === 0) {
            const datoRetorno = await this.addCatConsumoTarifas(catConsumoTarifasFor);
            catConsumoTarifasFor.id = datoRetorno.id;
          } else {
            await this.updateCatConsumoTarifas(catConsumoTarifasFor);
          }
          catConsumoTarifasFor.cambio = false;
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatConsumoTarifas");
      this.progressBar = false;
    }
  }

  async addCatConsumoTarifas(catConsumoTarifas) {
    try {
      const datoretorno = await this.catConsumoTarifasService
        .add(catConsumoTarifas)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatConsumoTarifas");
    }
  }

  async getAllCatConsumoTarifas() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catConsumoTarifasService.getAll().toPromise();
      this.catConsumoTarifas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConsumoTarifas");
      this.progressBar = false;
    }
  }

  async updateCatConsumoTarifas(catConsumoTarifas: CatConsumoTarifas) {
    try {
      const datoRetorno = await this.catConsumoTarifasService
        .update(catConsumoTarifas)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatConsumoTarifas");
    }
  }

  async deleteCatConsumoTarifas(catConsumoTarifas: CatConsumoTarifas) {
    try {
      const datoRetorno = await this.catConsumoTarifasService
        .delete(catConsumoTarifas.id)
        .toPromise();
      this.getAllCatConsumoTarifas();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatConsumoTarifas");
    }
  }

async getAllCatTipoPeriodos() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catTipoPeriodosService.getAll().toPromise();
      this.catTipoPeriodos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoPeriodosFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoPeriodosFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPeriodos");
      this.progressBar = false;
    }
  }

async getAllCatTipoConsumos() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catTipoConsumosService.getAll().toPromise();
      this.catTipoConsumos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoConsumosFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoConsumosFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoConsumos");
      this.progressBar = false;
    }
  }

async getAllCatDiametroTomas() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catDiametroTomasService.getAll().toPromise();
      this.catDiametroTomas = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDiametroTomasFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDiametroTomasFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatDiametroTomas");
      this.progressBar = false;
    }
  }

async getAllCatTipoUsos() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catTipoUsosService.getAll().toPromise();
      this.catTipoUsos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoUsosFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoUsosFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoUsos");
      this.progressBar = false;
    }
  }

async getAllCatTipoServicios() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.catTipoServiciosService.getAll().toPromise();
      this.catTipoServicios = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoServiciosFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoServiciosFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoServicios");
      this.progressBar = false;
    }
  }
}
